// extracted by css-extract-rspack-plugin
export default {"projectIssueDetailsStatus":"Jqo3VZmQ8wKkWEih","globalIssueDetailsStatus":"fHafZpZ4cwMgaUl8","userEmail":"hSaujzrEeMOI2Dek"};